import "core-js/features/symbol";
import "core-js/features/object";
import "core-js/features/function";
import "core-js/features/parse-int";
import "core-js/features/parse-float";
import "core-js/features/number";
import "core-js/features/math";
import "core-js/features/string";
import "core-js/features/date";
import "core-js/features/array";
import "core-js/features/regexp";
import "core-js/features/map";
import "core-js/features/weak-map";
import "core-js/features/array/from";
import "core-js/features/array/flat";
import "core-js/features/set";
import "core-js/features/promise";
import "regenerator-runtime/runtime";
import "./helper/i18n";

import { Component, createRef } from "react";
import { render } from "react-dom";
import { BrowserRouter, Switch, Route, Redirect} from "react-router-dom";

import ReactNotification from 'react-notifications-component';


import MasterLayout from "./view/layout/master/masterLayout";
import PageNotFoundViewController from "./viewController/static/pageNotFoundViewController";
import InternalErrorViewController from "./viewController/static/internalErrorViewController";
import RefreshViewController from "./viewController/static/refreshViewController";

import HomeViewController from "./viewController/overview/overviewViewController";
import DriverIdViewController from './viewController/driver/driverIdViewController';
import DriverViewController from './viewController/driver/driverViewController';
import UserIDViewController from './viewController/user/userIDViewController';
import UserViewController from './viewController/user/userViewController';
import OrderViewController from './viewController/order/orderViewController';
import OrderIDViewController from './viewController/order/orderIDViewController';
import NotificationsViewController from "./viewController/notifications/notificationsViewController";
import CouponViewController from "./viewController/coupon/couponViewController";
import SettlementViewController from "./viewController/settlement/settlementViewController";
import SettlementIDViewController from "./viewController/settlement/settlementIDViewController";
import ReparationViewController from "./viewController/reparation/reparationViewController";
import AdminViewController from "./viewController/admin/adminViewController";
import AdminIdViewController from "./viewController/admin/adminIdViewController";
import AddAdminViewController from "./viewController/admin/addAdminViewController";



import LoginViewController from "./viewController/preLogin/loginViewController";



require('bootstrap/dist/css/bootstrap.min.css');
require("./assets/css/dir-ltr.scss");
require("./assets/css/dir-rtl.scss");
require("./assets/css/theme.scss");
require("./assets/css/global.scss");
require('react-notifications-component/dist/theme.css');

class App extends Component 
{
	
	constructor(props) 
	{
		super(props);

		this.state =
		{
			optionalModalData: {},
			sideMenuKey: Math.random(),
			activeModal: undefined
		}

		this._child = createRef();
		this._isMounted = false;
	}

	refreshSideMenu() 
	{
		this._isMounted && this.setState({ ...this.state, sideMenuKey: Math.random() });
	}

	toggleModal(action, activeModal, optionalData = {}) 
	{
		if (action.toLowerCase() === "open") {
			this._isMounted && this.setState({ ...this.state, activeModal: activeModal, optionalModalData: optionalData });
		}
		else if (action.toLowerCase() === "close") {
			this._isMounted && this.setState({ ...this.state, activeModal: undefined });
		}
		else { }
	}

	componentDidMount() {
		this._isMounted = true;
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	render() {
		return (
			<>
				<Switch>
					<Route exact path="/500" render={(props) => <InternalErrorViewController toggleModal={this.toggleModal.bind(this)} {...props} />} />
					<Route exact path="/404" render={(props) => <PageNotFoundViewController toggleModal={this.toggleModal.bind(this)} {...props} />} />
					<Route exact path="/login" render={(props) => <LoginViewController toggleModal={this.toggleModal.bind(this)} {...props} />} />

					<>		
						<MasterLayout
							sideMenuKey={this.state?.sideMenuKey}
							toggleModal={this.toggleModal.bind(this)}
						>
							
							<Switch>
								<Route exact path="/" render={() => { return ( <Redirect to="/overview" />) }}/>
								<Route path="/overview" render={(props)=> <HomeViewController toggleModal={this.toggleModal.bind(this)} {...props}/>}/> 
								<Route path="/driver/:id" render={(props)=> <DriverIdViewController toggleModal={this.toggleModal.bind(this)} {...props}/>}/> 

								<Route path="/driver" render={(props)=> <DriverViewController toggleModal={this.toggleModal.bind(this)} {...props}/>}/>
								<Route path="/user/:id" render={(props)=> <UserIDViewController toggleModal={this.toggleModal.bind(this)} {...props}/>}/>
								<Route path="/user" render={(props)=> <UserViewController toggleModal={this.toggleModal.bind(this)} {...props}/>}/>
								<Route path="/order/:id" render={(props)=> <OrderIDViewController toggleModal={this.toggleModal.bind(this)} {...props}/>}/>
								<Route path="/order" render={(props)=> <OrderViewController toggleModal={this.toggleModal.bind(this)} {...props}/>}/>
								<Route path="/notifications" render={(props)=> <NotificationsViewController toggleModal={this.toggleModal.bind(this)} {...props}/>}/>
								<Route path="/coupon" render={(props)=> <CouponViewController toggleModal={this.toggleModal.bind(this)} {...props}/>}/>
								<Route path="/settlement/:id" render={(props)=> <SettlementIDViewController toggleModal={this.toggleModal.bind(this)} {...props}/>}/>
								<Route path="/settlement" render={(props)=> <SettlementViewController toggleModal={this.toggleModal.bind(this)} {...props}/>}/>
								<Route path="/reparation" render={(props)=> <ReparationViewController toggleModal={this.toggleModal.bind(this)} {...props}/>}/>
								<Route path="/admin/:id" render={(props)=> <AdminIdViewController toggleModal={this.toggleModal.bind(this)} {...props}/>}/>
								<Route path="/admin" render={(props)=> <AdminViewController toggleModal={this.toggleModal.bind(this)} {...props}/>}/>
								<Route path="/addAdmin" render={(props)=> <AddAdminViewController toggleModal={this.toggleModal.bind(this)} {...props}/>}/>

								<Route path="/refresh/:page" render={(props) => <RefreshViewController {...props}/>}/>	
								<Route exact path="*" render={(props) => <PageNotFoundViewController toggleModal={this.toggleModal.bind(this)} {...props}/>}/> 
							</Switch>
						</MasterLayout>	
					</>
				</Switch>
			</>
		);
	}
}

export default render(
	<BrowserRouter>
		<ReactNotification />
		<App />
	</BrowserRouter>,
	document.getElementById('root')
);
